export default __webpack_public_path__ + "static/media/icons-recibo-libre.00184781.svg";